import { TNotificationsNotifyType, TNotificationsCloseType } from '../../actions/notifications';

export const NOTIFICATIONS_NOTIFY_TYPE: TNotificationsNotifyType = 'notifications/notify';
export const NOTIFICATIONS_CLOSE_TYPE: TNotificationsCloseType = 'notifications/close';
